import { CheckCircle } from "lucide-react";

interface PaymentSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  orderId?: string;
  paymentMethod: string;
  onViewTickets?: () => void;
}

/**
 * Payment success modal.
 * Shows after successful payment confirmation.
 * Allows user to view tickets or continue.
 */
export function PaymentSuccessModal({
  isOpen,
  onClose,
  orderId: _orderId,
  paymentMethod,
  onViewTickets,
}: PaymentSuccessModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <div className="flex w-full max-w-md flex-col items-center justify-center gap-6 rounded-2xl bg-white p-8">
        <CheckCircle size={64} className="text-green-500" />

        <div className="flex flex-col items-center gap-2">
          <h2
            className="text-center font-bold text-black"
            style={{ fontSize: 24 }}
          >
            ¡Pago Exitoso!
          </h2>
          <p className="text-center text-gray-600 text-sm">
            Tu pago ha sido procesado correctamente con {paymentMethod}
          </p>
        </div>

        <p className="text-center text-sm text-gray-600">
          Recibirás tus tickets de inmediato por correo electrónico.
        </p>

        <div className="flex w-full flex-col gap-3">
          <button
            className="h-[50px] cursor-pointer rounded-[36px] border-none bg-secondary-120 font-semibold text-primary-110 transition-colors hover:opacity-90"
            style={{ fontSize: 14 }}
            onClick={onViewTickets || onClose}
          >
            Ver Mis Tickets
          </button>
          <button
            className="h-[50px] cursor-pointer rounded-[36px] border border-primary-110 bg-white font-semibold text-primary-110 transition-colors hover:bg-gray-50"
            style={{ fontSize: 14 }}
            onClick={onClose}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}
